import { mutationOptions, queryOptions } from '@tanstack/react-query';

import { API_MODULES } from '@lib/api/constants';
import DIContainer from '@lib/dicontainer';
import { CartItemInput } from '@lib/types';

const usecase = DIContainer.getCartUseCase();

export const cartKey = [API_MODULES.CART];

export const productCartKey = [...cartKey, 'products'];

export const productCartMutationKey = [...productCartKey, 'write'];

export const cartOptions = (accountId?: string) =>
  queryOptions({
    queryKey: [...cartKey, accountId],
    queryFn: ({ signal }) => usecase.list(signal),
    enabled: Boolean(accountId),
  });

export const addCartItemOptions = () =>
  mutationOptions({ mutationFn: (input: CartItemInput) => usecase.add(input) });

export const addCartItemsBatchOptions = () =>
  mutationOptions({
    mutationFn: ({
      idempotencyKey,
      items,
    }: {
      idempotencyKey: string;
      items: CartItemInput[];
    }) => usecase.addBatch(items, idempotencyKey),
  });

export const importCartOptions = () =>
  mutationOptions({
    mutationFn: (items: CartItemInput[]) => usecase.import(items),
  });

export const updateCartItemOptions = () =>
  mutationOptions({
    mutationFn: ({ id, quantity }: { id: string; quantity: number }) =>
      usecase.update(id, quantity),
  });

export const removeCartItemOptions = () =>
  mutationOptions({ mutationFn: (id: string) => usecase.remove(id) });

export const clearStoreCartOptions = () =>
  mutationOptions({
    mutationFn: (storeId: string) => usecase.clearStore(storeId),
  });

export const productCartOptions = (accountId?: string) =>
  queryOptions({
    queryKey: [...productCartKey, accountId],
    queryFn: ({ signal }) => usecase.listProducts(signal),
    enabled: Boolean(accountId),
  });

export const addProductCartOptions = () =>
  mutationOptions({
    mutationKey: productCartMutationKey,
    mutationFn: ({
      productOfferId,
      quantity,
    }: {
      productOfferId: string;
      quantity: number;
    }) => usecase.addProduct(productOfferId, quantity),
  });

export const updateProductCartOptions = () =>
  mutationOptions({
    mutationKey: productCartMutationKey,
    mutationFn: ({ id, quantity }: { id: string; quantity: number }) =>
      usecase.updateProduct(id, quantity),
  });

export const removeProductCartOptions = () =>
  mutationOptions({
    mutationKey: productCartMutationKey,
    mutationFn: (id: string) => usecase.removeProduct(id),
  });
